import React, {useEffect, useRef, useState} from 'react';
import './FilterChannelsAndChains.scss';
import {useDispatch, useSelector} from "react-redux";
import {Popover, Tooltip} from "antd";
import {CheckBox} from "../../../CheckBox";
import {Button} from "../../../Button";
import {ArrowLeftIcon, CloseStrokeIcon, FilterIcon, SearchIcon} from "../../../../image";
import {useTranslation} from "react-i18next";
import {ALL_FILTERS, getValueFilters} from "../../helpers";
import {DeleteFilterAction, SetFilterAction} from "../../../../redux/actions";
import {tagColors} from '../../../../utils/constants'

const FilterChannelsAndChains = ({pageType, onGetVideos}) => {
    const channels = useSelector(state => state.channels?.channels || []).sort((a, b) => {
        if (a.is_private) {
            return -1;
        }
        return 0;
    });
    const selectedChannelsFilterState = useSelector(state => state.filtersOrSort?.[pageType]?.filters?.[ALL_FILTERS.CHANNELS] || []);
    const selectedChainsFilterState = useSelector(state => state.filtersOrSort?.[pageType]?.filters?.[ALL_FILTERS.CHAINS] || []);
    const {t, i18n} = useTranslation();
    const [selectedIdsChannel, setSelectedIdsChannel] = useState([...selectedChannelsFilterState]);
    const [selectedIdsChains, setSelectedIdsChains] = useState([...selectedChainsFilterState]);
    const [open, setOpen] = useState(true);
    const [openTooltip, setOpenTooltip] = useState(false);
    const [isAll, setIsAll] = useState(false);
    const [searchText, setSearchText] = useState('');
    const allFilters = useSelector(state => state.filtersOrSort);
    const allFiltersValue = getValueFilters(allFilters, pageType);
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const [sortChannels, setSortChannels] = useState([]);
    const chainsList = useSelector(state => state.chains?.chainsList || []);

    const getLabel = () => {
        let text = '';
        let count = selectedChannelsFilterState.length + selectedChainsFilterState.length;
        if (count === 1 ) {
            const findChannel = channels.find((channel) => channel.id === selectedChannelsFilterState[0]);
            const findChain = chainsList.find((chain) => chain.id === selectedChainsFilterState[0]);

            text = findChannel?.name || findChain?.name;
        } else if (count > 1) {
            text = `+${count}`;
        } else {
            text = 'All'
        }
        return text
    }

    function handleOpenChange(newOpen) {
        setOpen(newOpen);
        setOpenTooltip(false);
    }


    function handleOpenTooltipChange(newOpen) {
        setOpenTooltip(newOpen);
    }

    const setValueFilter = (data) => {
        dispatch(SetFilterAction({
            pageType,
            filterType: ALL_FILTERS.CHANNELS,
            value: data
        }))
    }

    const onSelectedFilter = (value) => {
        let arr = [...selectedIdsChannel];
        if (selectedIdsChannel.includes(value)) {
            arr = arr.filter((item) => item !== value);
        } else {
            arr.push(value)
        }
        setSelectedIdsChannel(arr);
    }

    const onSelectedChainsFilter = (value) => {
        let arr = [...selectedIdsChains];
        if (selectedIdsChains.includes(value)) {
            arr = arr.filter((item) => item !== value);
        } else {
            arr.push(value)
        }
        setSelectedIdsChains(arr);
    }

    const handleCancelClick = () => {
        setOpen(false);
        setOpenTooltip(false);
        setValueFilter(selectedChannelsFilterState);
    }

    const handleAllClick = (isCheck) => {
        if (isCheck) {
            setSelectedIdsChannel(channels.map((item) => item.id));
            setSelectedIdsChains(chainsList.map((item) => item.id));
        } else {
            setSelectedIdsChannel([]);
            setSelectedIdsChains([]);
        }
    }

    const getVideos = async (type) => {
        let params = {
            ...allFiltersValue,
            channel_ids: selectedIdsChannel,
            chain_ids: selectedIdsChains,
        };
        if (!selectedIdsChannel?.length || type === 'delete') delete params?.channel_ids;
        if (!selectedIdsChains?.length || type === 'delete') delete params?.chain_ids;
        await onGetVideos(params);
    }

    const handleApplyClick = async () => {
        try {
            setOpen(false);
            setOpenTooltip(false);
            setValueFilter(selectedIdsChannel);
            dispatch(SetFilterAction({
                pageType,
                filterType: ALL_FILTERS.CHAINS,
                value: selectedIdsChains
            }))
            await getVideos()
        } catch (error) {
            console.log(error)
        }
    }

    const RenderTooltip = (props) => {
        if (selectedChannelsFilterState.length + selectedChainsFilterState.length > 1) {
            return (
                <Tooltip
                    open={open ? false : openTooltip}
                    onOpenChange={handleOpenTooltipChange}
                    placement="top"
                    title={<RenderTooltipText/>}
                >
                    <span className="filter-channels__label--text">{`${t('channels')}: ${getLabel()}`}</span>
                </Tooltip>
            )
        }
        return (<span className="filter-channels__label--text">{`${t('channels')}: ${getLabel()}`}</span>)
    }

    const RenderTooltipText = () => {
        const channelsFiltered = channels.filter((channel) => selectedChannelsFilterState.includes(channel.id));
        const chainsFiltered = chainsList.filter((chain) => selectedChainsFilterState.includes(chain.id));

        return (
            <div className="filter-channels__tooltip">
                {channelsFiltered.map((channel) => (
                    <div className="filter-channels__tooltip--text">{channel?.name}</div>
                ))}
                {chainsFiltered.map((chain) => (
                    <div className="filter-channels__tooltip--text">{chain?.name}</div>
                ))}
            </div>
        )
    }

    const getFilteredChannels = () => {
        if (searchText) {
            return channels.filter((channel) => (channel?.name || '').toLowerCase().includes(searchText.toLowerCase()))
        }
        return channels
    }

    const deleteFilter = async () => {
        await dispatch(DeleteFilterAction({
            pageType,
            filterType: ALL_FILTERS.CHANNELS
        }));
        await dispatch(DeleteFilterAction({
            pageType,
            filterType: ALL_FILTERS.CHAINS
        }));
        setSelectedIdsChains([])
        await getVideos('delete')
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && selectedIdsChannel.length) {
            handleApplyClick()
        }
    };

    const getChains = (id) => {
        return chainsList.filter((item) => item.channel.id === id);
    }

    useEffect(() => {
        setSelectedIdsChannel(selectedChannelsFilterState)
        setSelectedIdsChains(selectedChainsFilterState)
        setSearchText('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
        setSortChannels(sortChannels.sort((a) => selectedIdsChannel.includes(a.id) ? -1 : 1))

    }, [open]);

    useEffect(() => {
        setIsAll(selectedIdsChannel.length === channels.length)
    }, [selectedIdsChannel]);

    useEffect(() => {
        setSortChannels(channels);
    }, [channels]);

    return (
        <Popover
            arrow={false}
            trigger='click'
            placement="bottomLeft"
            overlayClassName='filter-channels'
            onOpenChange={handleOpenChange}
            destroyTooltipOnHide={true}
            open={open}
            content={
                <div className="filter-channels__container" onKeyDown={handleKeyDown}>
                    {channels?.length >= 7 ?
                        <div className="filter-channels__search" tabIndex={0}>
                            <div className="filter-channels__search--input-wrap">
                                <SearchIcon/>
                                <input
                                    value={searchText}
                                    onChange={(e) => setSearchText(e?.target?.value || '')}
                                    type="text" placeholder={t('input_search')}
                                    ref={inputRef}
                                />
                            </div>
                        </div>
                        : null}
                    {getFilteredChannels().length ?
                        <div style={{paddingRight: 16, paddingBottom: 4}}>
                            <div className="filter-channels__list custom-scroll">
                                {searchText ? null :
                                    <div className="filter-channels__list--item">
                                        <CheckBox
                                            checked={selectedIdsChannel.length === channels.length}
                                            onChange={() => {
                                                handleAllClick(!isAll);
                                            }}
                                            label={<div className="filter-channels__list--item-channel">{i18n.language === 'ru' ? 'Все' : 'All'}</div>}

                                        />
                                    </div>
                                }
                                {getFilteredChannels().map((channel, index) => (
                                    <div
                                        key={channel.id}
                                        className="filter-channels__list--item"
                                        style={{
                                            '--chain_bg': channel?.is_private ? 'rgba(26, 187, 120, 0.10)'
                                                : tagColors[index >= 5 ? index % 5 : index] + '14',
                                            '--chain_color': channel?.is_private ? "#1ABB78" : tagColors[index >= 5 ? index % 5 : index],
                                            '--chain_br': channel?.is_private ? "#1ABB78" : tagColors[index >= 5 ? index % 5 : index] + '14',
                                        }}
                                    >
                                            <CheckBox
                                                checked={selectedIdsChannel.includes(channel.id)}
                                                onChange={() => {
                                                    onSelectedFilter(channel.id)
                                                }}
                                                label={<div className="filter-channels__list--item-channel">{channel.name}</div>}
                                            />
                                        {getChains(channel.id).length ?
                                            <div className="filter-channels__list--item-chain">
                                                {getChains(channel.id).map((item) => (
                                                    <CheckBox
                                                        checked={selectedIdsChains.includes(item.id)}
                                                        onChange={() => {
                                                            onSelectedChainsFilter(item.id)
                                                        }}
                                                        label={
                                                            <Tooltip
                                                                placement="right"
                                                                title={item.name}
                                                            >
                                                                <div className="filter-channels__list--item-chain-label">{item.name}</div>
                                                            </Tooltip>
                                                        }
                                                    />
                                                ))}
                                            </div>
                                            : null
                                        }
                                    </div>
                                ))}
                            </div>
                        </div>
                        :
                       <>
                           {searchText ?
                               <div className="filter-channels__empty">
                                   <span>{t('no_found_search_item')}</span>
                               </div>
                               :
                               null
                           }
                       </>
                    }
                    <div className="filter-channels__footer">
                        <Button
                            text={t('button_cancel')}
                            variant="secondary"
                            size="xs"
                            onClick={handleCancelClick}
                        />
                        <Button
                            text={t('apply')}
                            variant="primary"
                            size="xs"
                            disabled={!selectedIdsChannel?.length && !selectedIdsChains.length}
                            onClick={handleApplyClick}
                        />
                    </div>
                </div>
            }
        >
            <div className={`filter-participant__label ${(selectedChannelsFilterState.length || selectedChainsFilterState.length) ? 'selected' : ''}`}>
                <div className={`filter-participant__wrap`}>
                    <FilterIcon/>
                    <RenderTooltip/>
                    {(!selectedChannelsFilterState.length || !selectedChainsFilterState.length) ?
                        <ArrowLeftIcon className={`filter-participant__label--arrow ${open ? 'open' : ''}`}/> : null}
                </div>
                {(selectedChannelsFilterState.length || selectedChainsFilterState.length) ?
                    <CloseStrokeIcon
                        onClick={deleteFilter}
                        className={`filter-participant__label--arrow`}
                    /> : null}
            </div>
        </Popover>
    );
};

export default FilterChannelsAndChains;